'use client';

import { ArrowRight } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Image } from 'react-datocms';
import { Heading } from '~/components/Heading';
import { Link } from '~/components/Link';
import { photoGradeClassName } from '~/utils/photoGrade';
import styles from './Header.module.css';
import type { HeaderProps } from './Header.types';

type BlogIndexHeaderProps = Pick<HeaderProps, 'heroImage' | 'title' | 'category' | 'slug'>;

export const BlogIndexHeader = ({ heroImage, title, category, slug }: BlogIndexHeaderProps) => {
  const t = useTranslations();
  const href = `/journal/${slug}`;

  return (
    <div data-test-id="BlogHeader" className={styles.blogIndexContainer}>
      <Link href={href} isUnstyled>
        {heroImage?.responsiveImage && (
          <>
            <Image
              key={heroImage.id}
              data={heroImage.responsiveImage}
              className={photoGradeClassName(heroImage.tags)}
              layout="fill"
              objectFit="cover"
              priority
              fadeInDuration={0}
            />
            <div className={styles.overlay} />
          </>
        )}
        <div className={styles.contentWrap}>
          <div className={styles.content}>
            <div className={styles.contentSpacing}>
              <div className={styles.headerWrap}>
                <Heading level="h1" variant="heading-xl">
                  {title}
                </Heading>
              </div>
              {category && (
                <div className={styles.bottomStrip}>
                  <div className={styles.category}>{category}</div>
                  <div className={styles.ctaLink}>
                    <p>{t('common.read_more')}</p>
                    <ArrowRight decorative width={20} height={20} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {heroImage?.author && <p className={styles.imageCredit}>{heroImage.author}</p>}
      </Link>
    </div>
  );
};
